import React, { ReactFragment } from 'react'
import {
  Dialog as MuiDialog,
  DialogTitle,
  Box,
  Button,
  IconButton,
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import theme from 'lib/theme'
import { useTranslation } from 'react-i18next'

type DialogProps = {
  title: string
  text: ReactFragment
  dialogOpen: boolean
  handleClose: () => void
  cancelText: string
  confirmText: string
  handleConfirm: () => void
  btnColor?: string
}

export const Dialog = ({
  title,
  text,
  dialogOpen,
  handleClose,
  cancelText,
  confirmText,
  handleConfirm,
  btnColor,
}: DialogProps) => {
  const { t } = useTranslation()
  return (
    <MuiDialog
      onClose={handleClose}
      open={dialogOpen}
      PaperProps={{ style: { padding: theme.spacing(2) } }}
      sx={{
        '& .MuiDialog-container': {
          '& .MuiPaper-root': {
            width: '400px',
            position: 'absolute',
            top: theme.spacing(4),
            right: 0,
          },
        },
      }}>
      <Box
        display='flex'
        justifyContent='space-between'
        alignItems='flex-start'>
        <Box>
          <DialogTitle
            sx={{
              fontWeight: 'bold',
              padding: `0 0 ${theme.spacing(2)}`,
            }}>
            {title}
          </DialogTitle>
        </Box>
        <IconButton
          sx={{
            paddingRight: 0,
            '&:hover': { backgroundColor: 'transparent' },
          }}
          aria-label={t('closeDeleteConfirmation')}
          onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      </Box>
      {text}
      <Box display='flex' justifyContent='space-between' mt={3}>
        <Button
          sx={{
            color: theme.palette.commonColors.black,
            backgroundColor: theme.palette.neutral.grey8,
            '&:hover': { backgroundColor: theme.palette.action.hover },
          }}
          onClick={handleClose}>
          {cancelText}
        </Button>
        <Button
          sx={{
            backgroundColor: btnColor ?? theme.palette.error.main,
            '&:hover': {
              backgroundColor: btnColor ?? theme.palette.error.light,
            },
          }}
          onClick={() => {
            handleConfirm()
            handleClose()
          }}>
          {confirmText}
        </Button>
      </Box>
    </MuiDialog>
  )
}
